import { render, staticRenderFns } from "./PersonaInfoForm.vue?vue&type=template&id=5060b866"
import script from "./PersonaInfoForm.vue?vue&type=script&lang=js"
export * from "./PersonaInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports